import React, {
  useContext, useMemo,
} from 'react';
import { Link } from 'react-router-dom';
import {
  Dropdown,
} from 'react-bootstrap';
import { faBookOpen, faLocationDot, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CiatAppContext, LogicaContext } from '../../../../providers';
import Avatar from '../../common/Avatar';

function ProfileDropdown() {
  const { data, onLogout } = useContext(LogicaContext);
  const { currentUser } = useContext(CiatAppContext);

  const avatarImg = useMemo(
    () => ((typeof currentUser.profile?.s_avatar) === 'string'
          && currentUser.profile.avatar && ('filename' in currentUser.profile.avatar)
      ? currentUser.profile.s_avatar : null),
    [currentUser.profile.avatar, currentUser.profile.s_avatar],
  );

  return (
    <Dropdown navbar as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar icon={faUser} src={avatarImg} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <Dropdown.Header className="d-inline-flex flex-wrap gap-1">
            <span>{currentUser.first_name}</span>
            <span>{currentUser.last_name}</span>
            <span>
              (
              {currentUser.username}
              )
            </span>
          </Dropdown.Header>
          <Dropdown.Item disabled="true">
            <div>
              <div className="d-flex gap-2 align-items-baseline">
                <FontAwesomeIcon icon={faBookOpen} fixedWidth />
                {currentUser?.profile?.inspection.repr}
              </div>
              <div className="d-flex gap-2 align-items-baseline">
                <FontAwesomeIcon icon={faLocationDot} fixedWidth />
                {currentUser?.profile?.authority.repr}
              </div>
            </div>

          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="/user/settings">
            Налаштування облікового запису
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Header className="text-wrap">
            Logica
          </Dropdown.Header>
          {!data ? (<div />

          ) : (
            <Dropdown.Item onClick={onLogout} title={`${data.position} у ${data.organizationId} ${data.organizationName}`}>
              Вихід (
              {data.subject}
              )
            </Dropdown.Item>
          )}
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="/logout/">
            Вийти
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default ProfileDropdown;
